import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useTagsQuery } from "./useTagsQuery";
import type { TagEntityType } from "../../../zodios/apiDefinitions/api/tags";
import type { ColumnOption } from "../../merchandising/components/tables/FilterWidget";

export function useCustomTagsFilter(entityType: TagEntityType, options?: { enabled?: boolean }): ColumnOption {
  const tagsQuery = useTagsQuery({ entityType }, options);
  const { t } = useTranslation(["tags"]);
  return useMemo((): ColumnOption => {
    const tags = tagsQuery.data?.results ?? [];
    return {
      name: t(($) => $.tags["Custom Tags"]),
      id: "tags_enhanced",
      format: "multi-select" as const,
      selectOptions: [
        { value: "all", label: t(($) => $.tags["All Tags"]) },
        ...tags.map((tag) => ({ value: tag.id, label: tag.name })),
      ],
      override: true,
      defaultValue: "all",
      operator: "custom" as const,
      filterFunction: (row, value) => {
        const filterValue = value as number | "all";
        if (filterValue === "all") {
          return true;
        }
        const entity = row as { tags_enhanced?: { id: number }[] };
        return (entity.tags_enhanced ?? []).some((tag) => tag.id === filterValue);
      },
    };
  }, [tagsQuery.data?.results, t]);
}
